import {createContext} from 'react';

const ChatBotDataContext = createContext({});

export default ChatBotDataContext;
